<template>
  <div>
    <div style="margin-top: 5px">
      <div>
        <el-row type="flex" :gutter="6">
          <el-col :span="3" v-if="appType === 'parent'">
            <!-- chọn khối -->
            <el-select
                style="width: 100%"
                clearable
                v-model="dataSearchParent.idGrade"
                placeholder="Chọn khối"
                @change="selectGrade"
            >
              <el-option
                  v-for="item in gradeOfSchoolList"
                  :key="item.id"
                  :value="item.id"
                  :label="item.gradeName"
              ></el-option>
            </el-select>
          </el-col>


          <el-col :span="3" v-if="appType === 'parent'">
            <!-- chọn lớp -->
            <el-select
                style="width: 100%"
                filterable
                clearable
                v-model="dataSearchParent.idClass"
                placeholder="Chọn lớp"
                @change="handleSearchParent"
                :disabled="!dataSearchParent.idGrade"
            >
              <el-option
                  v-for="item in classList"
                  :key="item.id"
                  :value="item.id"
                  :label="item.className"
              ></el-option>
            </el-select>
          </el-col>


          <el-col :span="5">
            <el-input
                :clearable="true"
                style="width: 100%"
                placeholder="Nhập tên hoặc số điện thoại"
                v-model="nameOrPhone"
                @keyup.enter.native="handleFilterData"
                @clear="handleFilterData"
            >
              <template #append>
                <el-button
                    icon="el-icon-search"
                    @click="handleFilterData"
                ></el-button>
              </template>
            </el-input>
          </el-col>


        </el-row>
      </div>
    </div>

    <div>
      <el-tabs type="card" v-model="activeName" @tab-click="handleClickTab">
<!--                 Tab  Parent -->
        <el-tab-pane label="App Onekids" name="appOnekids">
          <el-table
              border
              :data="configParentList"
              highlight-current-row
              :header-cell-style="tableHeaderColor"
              @selection-change="handleSelectionChangeParent"
              :max-height="$tableMaxHeight"
              v-loading="isLoading.parent"
              :element-loading-text="$tableLoading"
              element-loading-spinner="el-icon-loading"
              ref="tableParent"
          >
            <el-table-column
                type="selection"
                width="50"
                align="center"
                fixed="left"
            />

            <el-table-column
                type="index"
                label="STT"
                align="center"
                width="50"
                fixed="left"
            />

            <el-table-column
                label="Họ và tên (học sinh)"
                fixed="left"
            >
              <template v-slot:default="scope">
                <span>{{ scope.row.kidFullName }}</span>
              </template>
            </el-table-column>

            <el-table-column
                label="Họ và tên (bố/mẹ)"
                fixed="left"
            >
              <template v-slot:default="scope">
                <span>{{ scope.row.fullName }}</span>
              </template>
            </el-table-column>

            <el-table-column
                label="Số điện thoại"
                fixed="left"
            >
              <template v-slot:default="scope">
                <span>{{ scope.row.phone }}</span>
              </template>
            </el-table-column>

            <el-table-column align="center" width="150">
              <template #header>
                <span class="second-title">Tạo nhóm với phụ huynh</span>
                <br/>
                <el-checkbox
                    @change="checkBoxAllParentCreateGroupChatParent()"
                    v-model="checkAllParentCreateGroupChatParent"
                ></el-checkbox>
              </template>
              <template v-slot:default="scope">
                <el-checkbox
                    v-model="scope.row.parentCreateGroupChatParent"
                ></el-checkbox>
              </template>
            </el-table-column>

            <el-table-column align="center" width="150" label="Tạo nhóm với giáo viên">
              <template #header>
                <span class="second-title">Tạo nhóm với giáo viên</span>
                <br/>
                <el-checkbox
                    @change="checkBoxAllParentCreateGroupChatTeacher()"
                    v-model="checkAllParentCreateGroupChatTeacher"
                ></el-checkbox>
              </template>
              <template v-slot:default="scope">
                <el-checkbox
                    v-model="scope.row.parentCreateGroupChatTeacher"
                ></el-checkbox>
              </template>
            </el-table-column>

            <el-table-column align="center" width="150" label="Tạo nhóm với nhà trường">
              <template #header>
                <span class="second-title">Tạo nhóm với nhà trường</span>
                <br/>
                <el-checkbox
                    @change="checkBoxAllParentCreateGroupChatPlus()"
                    v-model="checkAllParentCreateGroupChatPlus"
                ></el-checkbox>
              </template>
              <template v-slot:default="scope">
                <el-checkbox
                    v-model="scope.row.parentCreateGroupChatPlus"
                ></el-checkbox>
              </template>
            </el-table-column>

            <el-table-column align="center" width="150" label="Chat với phụ huynh">
              <template #header>
                <span class="second-title">Chat với phụ huynh</span>
                <br/>
                <el-checkbox
                    @change="checkBoxAllParentChatSingleParent()"
                    v-model="checkAllParentChatSingleParent"
                ></el-checkbox>
              </template>
              <template v-slot:default="scope">
                <el-checkbox
                    v-model="scope.row.parentChatSingleParent"
                ></el-checkbox>
              </template>
            </el-table-column>

            <el-table-column align="center" width="150" label="Chat với giáo viên">
              <template #header>
                <span class="second-title">Chat với giáo viên</span>
                <br/>
                <el-checkbox
                    @change="checkBoxAllParentChatSingleTeacher()"
                    v-model="checkAllParentChatSingleTeacher"
                ></el-checkbox>
              </template>
              <template v-slot:default="scope">
                <el-checkbox
                    v-model="scope.row.parentChatSingleTeacher"
                ></el-checkbox>
              </template>
            </el-table-column>

            <el-table-column align="center" width="150" label="Chat với nhà trường">
              <template #header>
                <span class="second-title">Chat với nhà trường</span>
                <br/>
                <el-checkbox
                    @change="checkBoxAllParentChatSinglePlus()"
                    v-model="checkAllParentChatSinglePlus"
                ></el-checkbox>
              </template>
              <template v-slot:default="scope">
                <el-checkbox
                    v-model="scope.row.parentChatSinglePlus"
                ></el-checkbox>
              </template>
            </el-table-column>

            <template #empty>
              <div style="color: #409EFF; font-size: 16px">
                    <span>
                      <i class="el-icon-warning"/>
                      Không có dữ liệu
                    </span>
              </div>
            </template>
          </el-table>
        </el-tab-pane>

        <!-- Tab Teacher -->
        <el-tab-pane label="App Teacher" name="appTeacher">
          <el-table
              border
              :data="configTeacherList"
              highlight-current-row
              :header-cell-style="tableHeaderColor"
              @selection-change="handleSelectionChangeTeacher"
              :max-height="$tableMaxHeight"
              v-loading="isLoading.teachers"
              :element-loading-text="$tableLoading"
              element-loading-spinner="el-icon-loading"
              ref="tableTeacher"
          >
            <el-table-column
                type="selection"
                width="50"
                align="center"
                fixed="left"
            />

            <el-table-column
                type="index"
                label="STT"
                align="center"
                width="50"
                fixed="left"
            />

            <el-table-column
                label="Họ và tên"
                fixed="left"
            >
              <template v-slot:default="scope">
                <span>{{ scope.row.fullName }}</span>
              </template>
            </el-table-column>

            <el-table-column
                label="Số điện thoại"
                fixed="left"
            >
              <template v-slot:default="scope">
                <span>{{ scope.row.phone }}</span>
              </template>
            </el-table-column>

            <el-table-column align="center" width="150" label="Tạo nhóm với phụ huynh">
              <template #header>
                <span class="second-title">Tạo nhóm với phụ huynh</span>
                <br/>
                <el-checkbox
                    @change="checkBoxAllTeacherCreateGroupChatParent()"
                    v-model="checkAllTeacherCreateGroupChatParent"
                ></el-checkbox>
              </template>
              <template v-slot:default="scope">
                <el-checkbox
                    v-model="scope.row.teacherCreateGroupChatParent"
                ></el-checkbox>
              </template>
            </el-table-column>

            <el-table-column align="center" width="150" label="Tạo nhóm với giáo viên">
              <template #header>
                <span class="second-title">Tạo nhóm với giáo viên</span>
                <br/>
                <el-checkbox
                    @change="checkBoxAllTeacherCreateGroupChatTeacher()"
                    v-model="checkAllTeacherCreateGroupChatTeacher"
                ></el-checkbox>
              </template>
              <template v-slot:default="scope">
                <el-checkbox
                    v-model="scope.row.teacherCreateGroupChatTeacher"
                ></el-checkbox>
              </template>
            </el-table-column>

            <el-table-column align="center" width="150" label="Tạo nhóm với nhà trường">
              <template #header>
                <span class="second-title">Tạo nhóm với nhà trường</span>
                <br/>
                <el-checkbox
                    @change="checkBoxAllTeacherCreateGroupChatPlus()"
                    v-model="checkAllTeacherCreateGroupChatPlus"
                ></el-checkbox>
              </template>
              <template v-slot:default="scope">
                <el-checkbox
                    v-model="scope.row.teacherCreateGroupChatPlus"
                ></el-checkbox>
              </template>
            </el-table-column>

            <el-table-column align="center" width="150" label="Chat với phụ huynh">
              <template #header>
                <span class="second-title">Chat với phụ huynh</span>
                <br/>
                <el-checkbox
                    @change="checkBoxAllTeacherChatSingleParent()"
                    v-model="checkAllTeacherChatSingleParent"
                ></el-checkbox>
              </template>
              <template v-slot:default="scope">
                <el-checkbox
                    v-model="scope.row.teacherChatSingleParent"
                ></el-checkbox>
              </template>
            </el-table-column>

            <el-table-column align="center" width="150" label="Chat với giáo viên">
              <template #header>
                <span class="second-title">Chat với giáo viên</span>
                <br/>
                <el-checkbox
                    @change="checkBoxAllTeacherChatSingleTeacher()"
                    v-model="checkAllTeacherChatSingleTeacher"
                ></el-checkbox>
              </template>
              <template v-slot:default="scope">
                <el-checkbox
                    v-model="scope.row.teacherChatSingleTeacher"
                ></el-checkbox>
              </template>
            </el-table-column>

            <el-table-column align="center" width="150" label="Chat với nhà trường">
              <template #header>
                <span class="second-title">Chat với nhà trường</span>
                <br/>
                <el-checkbox
                    @change="checkBoxAllTeacherChatSinglePlus()"
                    v-model="checkAllTeacherChatSinglePlus"
                ></el-checkbox>
              </template>
              <template v-slot:default="scope">
                <el-checkbox
                    v-model="scope.row.teacherChatSinglePlus"
                ></el-checkbox>
              </template>
            </el-table-column>

            <template #empty>
              <div style="color: #409EFF; font-size: 16px">
                    <span>
                      <i class="el-icon-warning"/>
                      Không có dữ liệu
                    </span>
              </div>
            </template>
          </el-table>
        </el-tab-pane>
      </el-tabs>
    </div>
    <!--  Phân trang & tác vụ  -->
    <section style="margin-top: 20px">
      <el-row type="flex" :gutter="4">
        <el-col :span="22">
          <div class="container_nav_page">
            <el-pagination
                background
                layout="prev, pager, next, sizes"
                @size-change="handleSizeChange"
                @current-change="handleCurrentPageChange"
                :current-page.sync="page"
                :page-sizes="listSizePage"
                :total="totalRecords">
            </el-pagination>
          </div>
        </el-col>

        <el-col :span="2">
          <div class="container_task">
            <el-button
                type="success"
                size="medium"
                :loading="loadingButton"
                @click="submitForm()"
                icon="el-icon-circle-check"
            >
              <span>Lưu</span>
            </el-button>
          </div>
        </el-col>
      </el-row>
    </section>

  </div>
</template>

<script>
import StudentService from "@/services/StudentService";
import EmployeeDataService from "@/services/EmployeeService/EmployeeDataService";
import {mapState} from "vuex";

export default {
  components: {},
  created() {
    this.$store.dispatch('departmentStore/fetchDataDepartmentList');
    this.$store.dispatch('gradeModule/fetchDataGradeOfSchoolList');
    this.$store.dispatch('classStore/fetchDataClassListCommon');
    this.getDataInitial()
  },
  computed: {
    ...mapState('gradeModule', ['gradeOfSchoolList']),
    ...mapState('classStore', ['classListCommon']),
    ...mapState('departmentStore', ['departmentList']),
    classList() {
      return this.classListCommon.filter((x) => x.idGrade === this.dataSearchParent.idGrade);
    },
  },
  data() {
    return {
      activeName: "appOnekids",
      appType: "parent",
      nameOrPhone: "",
      page: 1,
      limit: 25,
      totalRecords: 0,
      configTeacherList: [],
      configParentList: [],
      listSizePage: [25, 50, 100, 500, 1000],
      dataSearchParent: {
        idGrade: null,
        idClass: null,
      },
      loadingButton: false,
      multipleSelectionParent: [],
      multipleSelectionTeacher: [],
      isLoading: {
        parent: false,
        teachers: false,
      },
      checkAllParentCreateGroupChatParent: false,
      checkAllParentCreateGroupChatTeacher: false,
      checkAllParentCreateGroupChatPlus: false,
      checkAllParentChatSingleParent: false,
      checkAllParentChatSingleTeacher: false,
      checkAllParentChatSinglePlus: false,

      checkAllTeacherCreateGroupChatParent: false,
      checkAllTeacherCreateGroupChatTeacher: false,
      checkAllTeacherCreateGroupChatPlus: false,
      checkAllTeacherChatSingleParent: false,
      checkAllTeacherChatSingleTeacher: false,
      checkAllTeacherChatSinglePlus: false,
    };
  },
  watch: {},
  methods: {
    tableHeaderColor() {
      return "background-color: #78a5e7;color: #fff;font-weight: bold;";
    },
    closeDialog() {
      this.$emit("dialog-close");
      setTimeout(() => {
        this.clearTabDefault();
      }, 300);
    },
    closeDialogByButton(fromData) {
      this.$refs[fromData].resetFields();
      this.$emit("dialog-close");
      setTimeout(() => {
        this.clearTabDefault();
      }, 300);
    },
    handleClickTab(tab) {
      this.nameOrPhone = ""
      this.page = 1
      this.limit = 25
      this.totalRecords = 0
      if (tab.name === "appOnekids") {
        this.appType = "parent"
        this.getDataInitial();
      } else {
        this.appType = "teacher"
        this.getDataInitial();
      }
    },
    getDataInitial() {
      if (this.appType === "teacher") {
        this.getDataInitialTeacher()
      } else {
        this.getDataInitialParent();
      }
    },

    getDataInitialParent() {
      StudentService.searchConfigRoleUserChatParent(this.page,
          this.limit, this.appType, this.nameOrPhone,
          this.dataSearchParent.idGrade, this.dataSearchParent.idClass)
          .then((resp) => {
            this.configParentList =
                resp.data.data.responseList
            this.totalRecords = resp.data.data.totalRecords
          })
          .catch((err) => {
            console.log(err);
          });
    },
    getDataInitialTeacher() {
      EmployeeDataService.searchConfigRoleUserChatEmployee(this.page, this.limit, this.appType, this.nameOrPhone)
          .then((resp) => {
            this.configTeacherList =
                resp.data.data.responseList
            this.totalRecords = resp.data.data.totalRecords
          })
          .catch((err) => {
            console.log(err);
          });
    },

    clearTabDefault() {
      this.activeName = "appOnekids";
    },
    handleSizeChange(value) {
      this.limit = value;
      this.getDataInitial();
    },
    handleCurrentPageChange(value) {
      this.page = value;
      this.getDataInitial();
    },

    handleFilterData() {
      this.page = 1;
      this.getDataInitial();
    },
    submitForm() {
      if (this.appType === 'parent') {
        if (this.multipleSelectionParent.length === 0) {
          this.$message({
            message: "Không có phụ huynh nào được chọn",
            type: "error",
          });
        } else {
          this.updateForManyParent();
        }
      } else {
        if (this.multipleSelectionTeacher.length === 0) {
          this.$message({
            message: "Không có giáo viên nào được chọn",
            type: "error",
          });
        } else {
          this.updateForManyTeacher();
        }
      }
    },

    updateForManyParent() {
      this.loadingButton = true;
      StudentService.updateForManyParent(this.multipleSelectionParent)
          .then((resp) => {
            this.$message({
              message: resp.data.message,
              type: resp.data.data === true ? "success" : "error",
            });
            setTimeout(() => {
              this.getDataInitialParent()
              this.loadingButton = false;
            }, 500);
            this.resetSelectionParent();
          })
          .catch((err) => {
            this.$message({
              message: err.data.message,
              type: "error",
            });
          })
          .finally(() => {
            this.loadingButton = false;
          });
    },

    updateForManyTeacher() {
      this.loadingButton = true;
      EmployeeDataService.updateForManyTeacher(this.multipleSelectionTeacher)
          .then((resp) => {
            this.$message({
              message: resp.data.message,
              type: resp.data.data === true ? "success" : "error",
            });
            setTimeout(() => {
              this.getDataInitialTeacher()
              this.loadingButton = false;
            }, 500);
            this.resetSelectionTeacher();
          })
          .catch((err) => {
            this.$message({
              message: err.data.message,
              type: "error",
            });
          })
          .finally(() => {
            this.loadingButton = false;
          });
    },

    handleSelectionChangeParent(val) {
      this.multipleSelectionParent = val;
    },
    handleSelectionChangeTeacher(val) {
      this.multipleSelectionTeacher = val;
    },

    handleSearchParent() {
      this.getDataInitial();
    },
    selectGrade() {
      this.dataSearchParent.idClass = "";
      this.getDataInitial();
    },

    resetSelectionParent() {
      this.multipleSelectionParent = [];
      this.$refs.tableParent.clearSelection();
    },
    resetSelectionTeacher() {
      this.multipleSelectionTeacher = [];
      this.$refs.tableTeacher.clearSelection();
    },
    checkBoxAllParentCreateGroupChatParent(){
      let dataList = this.configParentList;
      dataList.forEach((x) => {
        x.parentCreateGroupChatParent = this.checkAllParentCreateGroupChatParent
      });
    },
    checkBoxAllParentCreateGroupChatPlus(){
      let dataList = this.configParentList;
      dataList.forEach((x) => {
        x.parentCreateGroupChatPlus = this.checkAllParentCreateGroupChatPlus
      });
    },
    checkBoxAllParentChatSingleParent(){
      let dataList = this.configParentList;
      dataList.forEach((x) => {
        x.parentChatSingleParent = this.checkAllParentChatSingleParent
      });
    },
    checkBoxAllParentChatSingleTeacher(){
      let dataList = this.configParentList;
      dataList.forEach((x) => {
        x.parentChatSingleTeacher = this.checkAllParentChatSingleTeacher
      });
    },
    checkBoxAllParentChatSinglePlus(){
      let dataList = this.configParentList;
      dataList.forEach((x) => {
        x.parentChatSinglePlus = this.checkAllParentChatSinglePlus
      });
    },
    checkBoxAllParentCreateGroupChatTeacher(){
      let dataList = this.configParentList;
      dataList.forEach((x) => {
        x.parentCreateGroupChatTeacher = this.checkAllParentCreateGroupChatTeacher
      });
    },

    checkBoxAllTeacherCreateGroupChatParent(){
      let dataList = this.configTeacherList;
      dataList.forEach((x) => {
        x.teacherCreateGroupChatParent = this.checkAllTeacherCreateGroupChatParent
      });
    },

    checkBoxAllTeacherCreateGroupChatTeacher(){
      let dataList = this.configTeacherList;
      dataList.forEach((x) => {
        x.teacherCreateGroupChatTeacher = this.checkAllTeacherCreateGroupChatTeacher
      });
    },

    checkBoxAllTeacherCreateGroupChatPlus(){
      let dataList = this.configTeacherList;
      dataList.forEach((x) => {
        x.teacherCreateGroupChatPlus = this.checkAllTeacherCreateGroupChatPlus
      });
    },

    checkBoxAllTeacherChatSingleParent(){
      let dataList = this.configTeacherList;
      dataList.forEach((x) => {
        x.teacherChatSingleParent = this.checkAllTeacherChatSingleParent
      });
    },

    checkBoxAllTeacherChatSingleTeacher(){
      let dataList = this.configTeacherList;
      dataList.forEach((x) => {
        x.teacherChatSingleTeacher = this.checkAllTeacherChatSingleTeacher
      });
    },

    checkBoxAllTeacherChatSinglePlus(){
      let dataList = this.configTeacherList;
      dataList.forEach((x) => {
        x.teacherChatSinglePlus = this.checkAllTeacherChatSinglePlus
      });
    },

  },
};
</script>
<style>
.hideUpload > div {
  display: none;
}
</style>
<style lang="scss" scoped>
/deep/ .el-dialog__title {
  font-size: 25px;
  color: #606266;
}

/deep/ .el-dialog__body {
  padding-top: 0;
}

/deep/ .el-form-item__label {
  font-family: Arial, Helvetica, sans-serif;
}

/deep/ .el-button--primary {
  width: 100%;
  background: #409eff;
}

/deep/ .el-input.is-disabled .el-input__inner {
  color: #606266;
}

/deep/ .el-form-item.is-required:not(.is-no-asterisk) > .el-form-item__label:after {
  content: "*";
  color: #f56c6c;
  margin-left: 3px;
}

/deep/ .el-form-item.is-required:not(.is-no-asterisk) > .el-form-item__label:before {
  content: "";
  color: #f56c6c;
  margin-left: -4px;
}

/deep/ input::-webkit-outer-spin-button,
/deep/ input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/deep/ .el-input.is-disabled .el-input__inner {
  color: #606266;
  background: #e7e9ec;
  border: 1px solid #dcdfe6;
}

/deep/ .el-form-item__label {
  font-family: Arial, Helvetica, sans-serif;
}

/deep/ .el-table td,
/deep/ .el-table th {
  padding: 10px 0;
}

/deep/ .el-tabs__nav {
  background: #a0a19ce0;
}

.el-select {
  display: block;
}

.tab-infor-button {
  text-align: right;
  margin-top: 20px;
}

.bg-purple {
  background: #d3dce6;
}

.grid-content {
  border-radius: 4px;
  min-height: 36px;
}

.group-radio-status {
  margin: 0 50px;

  .kids-status {
    margin-bottom: 10px;
  }
}

.table-data {
  width: 60%;
  border-collapse: collapse;
  border: 1px solid #ebeef5;
  margin: 0 auto;
}

.wrapper-table {
  overflow-y: scroll;
  border-bottom: 1px solid #ebeef5;
}

.button-left-class {
  margin-right: 5px;
  width: 200px;
}

.button-click-left {
  margin-top: 5px;
  display: flex;
  align-items: center;
  margin-bottom: -20px;
  position: relative;
  z-index: 1
}

.button-click-left .el-select {
  margin-right: 10px;
}

.footer_task {
  margin-top: 20px;
}
/deep/ .el-tabs__nav {
  background: #a0a19ce0;
}
/deep/ .el-tabs__nav-scroll {
  float: right;
}

/deep/ .el-tabs__header {
  margin-bottom: 0;
}
/deep/ .el-tabs--card > .el-tabs__header .el-tabs__item.is-active {
  border-bottom-color: #78a5e7;
}

/deep/ .el-tabs--card > .el-tabs__header {
  border-bottom: none;
}
/deep/ .el-tabs__item.is-active {
  color: white;
  background: #78a5e7;
}
/deep/ .el-tabs__item {
  color: white;
}
.container_task {
  display: flex;
  justify-content: right;
}
.container_nav_page {
  display: flex;
  justify-content: center;
}
</style>
